export default __webpack_public_path__ + "static/media/platform_image_2.9e5a2134.png";